import React from 'react';
import PropTypes from 'prop-types';

import { WithTooltip } from 'components/common/Elements/Elements';
import LocationBody from './parts/LocationBody/LocationBody';
import { countryCodes } from 'data/countryCodes';

const Location = props => {
  const { withTooltip, country } = props;

  const countryFullName = countryCodes.find(
    ({ code }) => code === country
  )?.name;

  return (
    <>
      {withTooltip ? (
        <WithTooltip text={countryFullName}>
          <div>
            <LocationBody {...props} countryFullName={countryFullName} />
          </div>
        </WithTooltip>
      ) : (
        <LocationBody {...props} countryFullName={countryFullName} />
      )}
    </>
  );
};

Location.propTypes = {
  withTooltip: PropTypes.bool,
  country: PropTypes.string
};

export default Location;
